<template>
  <!-- name: '登记可捐衣物-未登记' -->
  <div class="registerDefaultWrap">
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_line1.svg"
      alt=""
      class="lineClass line1"
    />
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_line2.svg"
      alt=""
      class="lineClass line2"
    />
    <h3 class="titleClass">衣物登记说明</h3>
    <p>
      如果衣物缺口暂时没有您想捐的衣物，请整理并再次登记您想捐的衣物信息。有新需求上线，如果符合您登记的信息时，我们会第一时间通知您。
    </p>
    <p>登记的可捐衣物需要符合8成新，无污渍的捐赠要求，感谢您的支持。</p>
    <button @click="handleAddClothesInfo">添加衣物信息</button>
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_butterfly.png"
      alt=""
      class="img_butterfly"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    handleAddClothesInfo() {
      this.$emit("setIsDefault", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.registerDefaultWrap {
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #fbf0f6, rgba(255, 255, 255, 0) 30%),
    linear-gradient(215deg, #e9f1f8, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #fff, #fff 45%);
  overflow: auto;
  position: relative;
  .lineClass {
    position: absolute;
    &.line1 {
      top: -72px;
      right: 16px;
      width: 238px;
      height: 162px;
    }
    &.line2 {
      top: 501px;
      left: 0px;
      width: 117px;
      height: 57px;
    }
  }
  .titleClass {
    width: 100%;
    height: 56px;
    font-size: 44px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 56px;
    margin-top: 110px;
    margin-bottom: 56px;
  }
  p {
    width: 560px;
    font-size: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    text-indent: 30px;
    margin: 0px auto;
    text-align: left;
  }
  button {
    width: 560px;
    height: 96px;
    background: #ffffff;
    border-radius: 56px;
    border: 1px solid #dddddd;
    margin-top: 64px;
    font-size: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 96px;
    text-indent: 64px;
    text-align: left;
    background-image: url("https://img.bbalt.cn/imgh5/userCenter/icon_next.png");
    background-repeat: no-repeat;
    background-size: 40px 40px;
    background-position: 480px 28px;
  }
  .img_butterfly {
    width: 255px;
    height: 255px;
    position: absolute;
    bottom: 37px;
    right: 26px;
  }
}
</style>
